import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Container, Row, Col } from "react-bootstrap";
import { datablogs, meta } from "../../content_option";
import { Link } from "react-router-dom";
import "./style.css";

export const Blogs = () => {
  return (
    <HelmetProvider>
      <Container className="About-header">
        <Helmet>
          <meta charSet="utf-8" />
          <title> Blogs | {meta.title} </title>{" "}
          <meta name="description" content={meta.description} />
        </Helmet>
        <Row className="mb-2 mt-3 pt-md-3">
          <Col lg="8">
            <h1 className="display-4 mb-4"> Blogs </h1>{" "}
            <hr className="t_border my-4 ml-0 text-left" />
          </Col>
        </Row>
       <div className="blogs-grid">
  {datablogs.map((data, i) => (
    <Link to={data.link} key={i} className="blog-card-link">
  <article className="blog-card">
    <img src={data.img} alt={data.title} loading="lazy" />
    <div className="blog-content">
      <div className="blog-meta">
        <span>{data.date}</span>
        <span>•</span>
        <span>{data.readTime}</span>
      </div>

      <div className="blog-title">{data.title}</div>

      <p className="blog-description">{data.description}</p>

      <div className="blog-tags">
        {data.tags.map((tag, idx) => (
          <span key={idx} className="tag">#{tag}</span>
        ))}
      </div>
    </div>
  </article>
</Link>
  ))}
</div>
      </Container>
    </HelmetProvider>
  );
};
